// JWT Header type
export type JWTHeader = {
  alg: string
  typ: string
}
